import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IPreInrolatAddPayload, IPreInrolatEditPayload } from './pre-enrolled-accounts.interface';

@Injectable({
    providedIn: 'root'
})
export class PreEnrolledAccountsService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getPreInrolatiDTURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.getInrolatiDT;
    private getPreInrolatByIdURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.getInrolat;
    private storePreInrolatURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.storeInrolat;
    private putPreInrolatURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.putInrolat;
    private getAddressByIdURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.getInrolatAddress;
    private getPreInrolatiListURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.getInrolatiList;
    private getPreInrolatiActiveURL = this.basePath + environment.interop.platform.nomenclatoare.inrolat.getInrolatiListActive;

    constructor(private http: HttpClient) { }

    getPreInrolatiDT() {
        return this.http.get(this.getPreInrolatiDTURL, this.httpOptions);
    }

    getPreInrolatById(id: number) {
        return this.http.get(this.getPreInrolatByIdURL + id, this.httpOptions);
    }

    addPreInrolat(client: IPreInrolatAddPayload) {
        return this.http.post(this.storePreInrolatURL, client, this.httpOptions);
    }

    updatePreInrolat(client: IPreInrolatEditPayload) {
        return this.http.put(this.putPreInrolatURL, client, this.httpOptions);
    }

    getAddressById(id: number) {
        return this.http.get(this.getAddressByIdURL + id, this.httpOptions);
    }

    getPreInrolatiList() {
        return this.http.get(this.getPreInrolatiListURL, this.httpOptions);
    }

    getPreInrolatiActive() {
        return this.http.get(this.getPreInrolatiActiveURL, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
